import { useEffect, useState } from 'react';

import { ICompetitionResumeResponseDto } from 'src/core/gamefication/dto/competition/competition-resume-response.dto';

import * as badgesGroupsApi from '../api/badgesGroupsApi';

export const useGetAllCompetitions = () => {
  const [data, setData] = useState<Array<ICompetitionResumeResponseDto>>([]);
  const [error, setError] = useState<unknown>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const fetchData = async (): Promise<void> => {
    try {
      const response = await badgesGroupsApi.getCompetitions();
      setData(response.data);
    } catch (error) {
      setError(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return [data, error, loading] as const;
};
